export const ADD_USER = "ADD_USER";

export const DELETE_USER = "DELETE_USER";

export const CHANGE_THEME = "CHANGE_THEME";

export const ADD_RECEIVER = "ADD_RECEIVER";

export const DELETE_RECEIVER = "DELETE_RECEIVER";


// WEBPACK FOOTER //
// ./src/constants/actionConstants.js